import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkModal } from '../../../components/ATS/LinkModal/LinkModal';
import { ScriptService } from '../../../controllers/ScriptService';
import { getAltiboxServiceUrl } from '../../../utils/svodUtil';

export interface SvodDeepLinkProps {
  providerIdentifier: string;
  providerName: string;
  children: JSX.Element;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export function SvodDeepLink({ providerIdentifier, providerName, children, onClick }: SvodDeepLinkProps) {
  const { t } = useTranslation();

  const isDKUser = ScriptService.isDKUser();
  const buttonText = isDKUser ? t('svod:popup_continue_da') : t('svod:popup_continue_no');
  const description = isDKUser ? t('svod:popup_description_da') : t('svod:popup_description_no');

  return (
    <LinkModal
      id={providerIdentifier}
      title={t('svod:popup_title', { name: providerName })}
      description={description}
      onClick={onClick}
      primaryButton={{
        title: buttonText,
        url: getAltiboxServiceUrl(providerIdentifier),
      }}
    >
      {children}
    </LinkModal>
  );
}
